import { UI } from '../../core/store.js';
import { vAsset, vGallery } from './view.js';
import { actions, changes } from './actions.js';
import { reviewKey, timelineClick, uploadPhotos } from './hooks.js';

export default {
  id: 'gallery', label: 'Client gallery', icon: 'film', nav: true, show: () => true,
  view: vGallery, actions, changes,
  takeover: { when: () => !!UI.aid, view: vAsset },
  keys: [reviewKey], clicks: [timelineClick],
  uploads: { photos: uploadPhotos }
};
